import { useTranslation } from "react-i18next";
import { FaCheckCircle } from "react-icons/fa";

import { ReactComponent as TopSmoothy } from "../../../assets/top-smoothy.svg";
import { getLanguage } from "../../../utils/getLanguage";

const Home = () => {
  const { t } = useTranslation();
  const lang = getLanguage();

  return (
    <div className="flex justify-center bg-blue-500">
      <div className="relative flex w-full flex-col-reverse justify-between gap-10 py-20 lg:flex-row">
        {/* Left Side - Text Content */}
        <div className="max-w-xl text-white">
          <h1 className="mb-6 text-5xl font-extrabold leading-tight sm:text-7xl rtl:leading-snug">
            {t("the_coding_community_for_kids")}
          </h1>
          <p className="mb-6 text-lg">{t("unique_learning_experience")}</p>

          <ul className="mb-8 space-y-3">
            {[
              t("expanding_thinking_skills"),
              t("developing_communication_skills"),
              t("improving_academic_skills"),
            ].map((item, idx) => (
              <li key={idx} className="flex items-center gap-2">
                <FaCheckCircle className="text-lg text-blue-200" />
                <span className="text-base">{item}</span>
              </li>
            ))}
          </ul>

          <button className="wavy-btn relative mt-1 w-1/2 rounded-3xl border-4 border-[#e6bc40] bg-[#FFD03F] p-4 font-semibold text-gray-800 transition duration-200">
            {t("register_account_free")}
          </button>
        </div>

        {/* Right Side - Visuals */}
        <div className="absolute bottom-0 w-2/3 max-w-md lg:max-w-xl xl:max-w-4xl ltr:left-128 rtl:right-128">
          <TopSmoothy className="h-auto w-full" />
        </div>
      </div>
    </div>
  );
};

export default Home;
